export enum TeamSyncOptions {
	NoStorage,
	MinimalStorage,
	OptimalPerformance,
}
